const colorDictionary = {
  Dark: '#19124F',
  Light: '#FFFFFF',
};

const getColor = (colorScheme?: string | null) => {
  if (!colorScheme || !(colorScheme in colorDictionary)) {
    return colorDictionary.Dark;
  }
  return colorDictionary[colorScheme];
};

export { colorDictionary, getColor };
